<template>
  <div ref="wrapper" class="base-answer">
    <div
      :style="{ zIndex }"
      :data-order="order"
      :data-assist="disabled ? 'off' : 'focus'"
      class="relative mx-auto"
      :class="{ [wrapClass]: wrapClass }"
    >
      <slot />
    </div>
    <!--end::wrapper-inner-->
  </div>
  <!--end::wrapper-outer-->
</template>

<script>
import * as _ from 'lodash'
import { PLAYS } from '@state/modules/play'

export default {
  props: {
    id: {
      type: Number,
      required: false,
      default: null,
    },
    order: {
      type: Number,
      required: false,
      default: undefined,
    },
    zIndex: {
      type: Number,
      required: false,
      default: undefined,
    },
    listen: {
      type: String,
      required: false,
      default: () => 'click',
    },
    validate: {
      type: Function,
      required: false,
      default: () => true,
    },
    manualFit: {
      type: Boolean,
      required: false,
    },
    wrapClass: {
      type: String,
      required: false,
      default: undefined,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
  },
  computed: {
    slotElement() {
      return _.get(this.$slots, 'default[0].elm')
    },
    wrapperElement() {
      return this.$refs.wrapper
    },
  },
  mounted() {
    if (this.id) {
      this.wrapperElement.addEventListener(this.listen, this.proxy)
      const answerPos =
        this.slotElement && this.slotElement.getBoundingClientRect
          ? this.slotElement.getBoundingClientRect()
          : { x: -1, y: -1 }

      // set wrapper element width
      if (!this.manualFit) {
        if (answerPos.width > 0 && answerPos.height > 0) {
          this.wrapperElement.style.width = Number(answerPos.width) + 'px'
          this.wrapperElement.style.height = Number(answerPos.height) + 'px'
        }
      }

      // save the answer element position
      this.$store
        .dispatch(PLAYS.NAMESPACE(PLAYS.ADD_ANSWER_POSITION), {
          id: this.id,
          position: answerPos,
        })
        .catch((e) => this.$log.warn(`${this.id} : not measurement answer element.`, e))
    }
  },
  destroyed() {
    this.wrapperElement.removeEventListener(this.listen, this.proxy)
  },
  methods: {
    proxy(event) {
      // trigger before callback event.
      this.$emit('before', event)

      // if have validate function
      if (!this.validate()) {
        // emit validation fail event
        this.$emit('validate-fail', event)
        return
      }

      // emit validation success event
      this.$emit('validate-success', event)

      // if the passed parameter is an event object
      if (event && event.stopPropagation) {
        // stop event propagation
        event.stopPropagation()
        window.audios.click.play()
      }

      // create and broadcast custom event.
      const customEvent = new CustomEvent('answer', { bubbles: true })
      event.target.dispatchEvent(customEvent)

      // trigger callback event.
      this.$emit('after', event)
    },
  },
}
</script>
